import { Box, type BoxProps, SxProps, Theme, useTheme } from '@mui/material';

function AILogo({
  size = 32,
  sx,
  ...props
}: {
  size?: number | string;
  sx?: SxProps<Theme>;
} & BoxProps) {
  const theme = useTheme();

  return (
    <Box
      component="svg"
      width={size}
      height={size}
      sx={sx}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* eslint-disable-next-line @watershed/literals-must-be-i18n-ready */}
      <title>AI logo</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.625C12.0731 0.625 15.375 3.9269 15.375 8C15.375 12.0731 12.0731 15.375 8 15.375C3.9269 15.375 0.625 12.0731 0.625 8C0.625 3.9269 3.9269 0.625 8 0.625ZM9.01465 8.95117C7.54616 10.6332 6.13333 11.625 4.5 11.625C3.94888 11.625 3.36807 11.5101 2.82715 11.2773C3.91345 12.9883 5.82323 14.125 8 14.125C10.5434 14.125 12.7235 12.5743 13.6494 10.3672C13.228 10.5327 12.7534 10.625 12.25 10.625C11.4457 10.625 10.6859 10.2679 10.0684 9.84277C9.67888 9.57462 9.32179 9.26261 9.01465 8.95117ZM4.5 5.625C3.87782 5.625 3.20677 5.83536 2.70312 6.23828C2.2454 6.60446 1.918 7.13297 1.87891 7.85352C1.87776 7.90222 1.875 7.95102 1.875 8C1.875 8.79593 2.21492 9.37116 2.70312 9.76172C3.20677 10.1646 3.87782 10.375 4.5 10.375C5.61069 10.375 6.73623 9.69156 8.18457 8C6.73623 6.30844 5.61069 5.625 4.5 5.625ZM12.25 6.625C11.8044 6.625 11.2945 6.83048 10.7773 7.18652C10.4311 7.42492 10.1103 7.71412 9.83691 8C10.1103 8.28588 10.4311 8.57508 10.7773 8.81348C11.2945 9.16952 11.8044 9.375 12.25 9.375C13.5254 9.375 14.125 8.67046 14.125 8C14.125 7.32954 13.5254 6.625 12.25 6.625ZM8 1.875C5.82352 1.875 3.91353 3.01106 2.82715 4.72168C3.36797 4.48904 3.949 4.375 4.5 4.375C6.13315 4.375 7.54634 5.36619 9.01465 7.04785C9.32168 6.73658 9.67909 6.42524 10.0684 6.15723C10.6859 5.73207 11.4457 5.375 12.25 5.375C12.7533 5.375 13.2281 5.46645 13.6494 5.63184C12.7233 3.42517 10.5431 1.875 8 1.875Z"
        fill={theme.palette.grey100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.625C12.0731 0.625 15.375 3.9269 15.375 8C15.375 12.0731 12.0731 15.375 8 15.375C3.9269 15.375 0.625 12.0731 0.625 8C0.625 3.9269 3.9269 0.625 8 0.625ZM9.01465 8.95117C7.54616 10.6332 6.13333 11.625 4.5 11.625C3.94888 11.625 3.36807 11.5101 2.82715 11.2773C3.91345 12.9883 5.82323 14.125 8 14.125C10.5434 14.125 12.7235 12.5743 13.6494 10.3672C13.228 10.5327 12.7534 10.625 12.25 10.625C11.4457 10.625 10.6859 10.2679 10.0684 9.84277C9.67888 9.57462 9.32179 9.26261 9.01465 8.95117ZM4.5 5.625C3.87782 5.625 3.20677 5.83536 2.70312 6.23828C2.2454 6.60446 1.918 7.13297 1.87891 7.85352C1.87776 7.90222 1.875 7.95102 1.875 8C1.875 8.79593 2.21492 9.37116 2.70312 9.76172C3.20677 10.1646 3.87782 10.375 4.5 10.375C5.61069 10.375 6.73623 9.69156 8.18457 8C6.73623 6.30844 5.61069 5.625 4.5 5.625ZM12.25 6.625C11.8044 6.625 11.2945 6.83048 10.7773 7.18652C10.4311 7.42492 10.1103 7.71412 9.83691 8C10.1103 8.28588 10.4311 8.57508 10.7773 8.81348C11.2945 9.16952 11.8044 9.375 12.25 9.375C13.5254 9.375 14.125 8.67046 14.125 8C14.125 7.32954 13.5254 6.625 12.25 6.625ZM8 1.875C5.82352 1.875 3.91353 3.01106 2.82715 4.72168C3.36797 4.48904 3.949 4.375 4.5 4.375C6.13315 4.375 7.54634 5.36619 9.01465 7.04785C9.32168 6.73658 9.67909 6.42524 10.0684 6.15723C10.6859 5.73207 11.4457 5.375 12.25 5.375C12.7533 5.375 13.2281 5.46645 13.6494 5.63184C12.7233 3.42517 10.5431 1.875 8 1.875Z"
        fill="url(#paint0_linear_3162_51565)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3162_51565"
          x1="0.571429"
          y1="5.71429"
          x2="21.1429"
          y2="16.5714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.palette.cobalt20} />
          <stop offset="1" stopColor={theme.palette.cobalt50} />
        </linearGradient>
      </defs>
    </Box>
  );
}

export default AILogo;
